module.exports = __webpack_public_path__ + "static/img/1.ac3bab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/1.png
// module id = ritG
// module chunks = 0